import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { openModal, closeModal, MODAL_TYPES } from './modalActions';
import { showSnack } from './snackbarActions';
export var UPDATE_AFFILIATE_SUCCESS = 'UPDATE_AFFILIATE_SUCCESS';
export var GET_AFFILIATE_SUCCESS = 'GET_AFFILIATE_SUCCESS';
export var GET_AFFILIATE_COUNT_SUCCESS = 'GET_AFFILIATE_COUNT_SUCCESS';
export var updateAffiliate = function updateAffiliate(formValues) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var AffiliateTag, _getState$user$userIn, UserId, OMSId, AffiliateId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              AffiliateTag = formValues.tag;
              _getState$user$userIn = getState().user.userInfo, UserId = _getState$user$userIn.UserId, OMSId = _getState$user$userIn.OMSId, AffiliateId = _getState$user$userIn.AffiliateId;
              _context.next = 4;
              return dispatch(callAPI('AddUserAffiliateTag', {
                OMSId: OMSId,
                UserId: UserId,
                AffiliateId: AffiliateId,
                AffiliateTag: AffiliateTag
              })).then(function (res) {
                if (res.result) {
                  dispatch(updateAffiliateSuccess(AffiliateTag));
                  dispatch(closeModal(MODAL_TYPES.NEW_AFFILIATE_KEY));
                } else {
                  dispatch(showSnack({
                    id: 'createAffiliateError',
                    // context.t('Could not create tag or tag already in use')
                    text: 'Could not create tag or tag already in use',
                    type: 'warning'
                  }));
                }
              });
            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getAffiliate = function getAffiliate(OMSId, UserId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(callAPI('GetUserAffiliateTag', {
                OMSId: OMSId,
                UserId: UserId
              })).then(function (res) {
                dispatch(getAffiliateSuccess(res));
              });
            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getAffiliateCount = function getAffiliateCount() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(callAPI('GetUserAffiliateCount', {})).then(function (res) {
                return dispatch(getAffiliateCountSuccess(res));
              });
            case 2:
              return _context3.abrupt('return', _context3.sent);
            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));
    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var openAffiliateModal = function openAffiliateModal() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(openModal(MODAL_TYPES.NEW_AFFILIATE_KEY));
            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var updateAffiliateSuccess = function updateAffiliateSuccess(payload) {
  return {
    type: UPDATE_AFFILIATE_SUCCESS,
    payload: payload
  };
};
export var getAffiliateSuccess = function getAffiliateSuccess(payload) {
  return {
    type: GET_AFFILIATE_SUCCESS,
    payload: payload
  };
};
export var getAffiliateCountSuccess = function getAffiliateCountSuccess(payload) {
  return {
    type: GET_AFFILIATE_COUNT_SUCCESS,
    payload: payload
  };
};